import {
  TrackerMealConnectorApollo,
  TrackerEditMealConnectorApollo,
  TrackerEditQuickMealConnectorApollo,
  useAppContext,
  TrackerRemoveMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  formatIsoDate,
} from '@front-activerse/common-components';
import { useParams, useLocation } from 'react-router-dom';
import TrackerMealContainer from './TrackerMealContainer';

const TrackerMealPage: React.FC = () => {
  const { date, dietMealId } = useParams();
  const dateString = date ? date : formatIsoDate(new Date());
  const { post } = useAppContext();

  const location = useLocation();

  if (!dietMealId) {
    return <div>Missing parameters</div>;
  }

  return (
    <TrackerMealConnectorApollo mealId={+dietMealId}>
      {(trackerMealData: any) => (
        <TrackerEditMealConnectorApollo post={post} originalDate={dateString}>
          {({ editMeal }: { editMeal: (input: any) => Promise<any> }) => (
            <TrackerEditQuickMealConnectorApollo post={post} originalDate={dateString}>
              {({ editQuickMeal }) => (
                <TrackerRemoveMealConnectorApollo date={dateString}>
                  {({ removeMeal }) => (
                    <SaveAsUserMealConnectorApollo post={post}>
                      {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                        <TrackerMealContainer
                          {...trackerMealData}
                          loading={trackerMealData.loading}
                          editMeal={editMeal}
                          editQuickMeal={editQuickMeal}
                          key={location.key}
                          removeMeal={removeMeal}
                          date={dateString}
                          saveAsUserMeal={saveAsUserMeal}
                          dietMealId={dietMealId}
                        />
                      )}
                    </SaveAsUserMealConnectorApollo>
                  )}
                </TrackerRemoveMealConnectorApollo>
              )}
            </TrackerEditQuickMealConnectorApollo>
          )}
        </TrackerEditMealConnectorApollo>
      )}
    </TrackerMealConnectorApollo>
  );
};

export default TrackerMealPage;
